import { useEffect, useState, useCallback } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';
import { firestore } from 'settings/firebase'; // adjust your import
import { useAuth } from '@merq/web-ui/dist/providers/userProvider';
import useInterval from './useInterval';

const currentVersion = import.meta.env.VITE_APP_VERSION;
const versionPath = import.meta.env.VITE_ENV === 'staging' ? '/appVersionStaging' : 'appVersion';
const DEBUG = false;
const TIME_LIMIT = 180; // 3 minutes

const useAppVersionWatcher = () => {
  const isDev = import.meta.env.VITE_ENV === 'development';
  const [updateRequired, setUpdateRequired] = useState(false);
  const [timer, setTimer] = useState(TIME_LIMIT);
  const auth = useAuth();
  const isInternalUser = auth.user?.email?.endsWith('@merqube.com');
  const progress = ((TIME_LIMIT - timer) / TIME_LIMIT) * 100;

  useInterval(
    () => {
      setTimer(prev => (prev > 0 ? prev - 1 : 0));
    },
    updateRequired && isInternalUser ? 1000 : null
  ); // every 1 second

  useEffect(() => {
    if (timer === 0 && updateRequired && isInternalUser) {
      window.location.reload();
    }
  }, [timer, updateRequired, isInternalUser]);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(firestore, 'config', versionPath), snap => {
      const serverVersion = snap.data()?.version;
      const isMandatory = snap.data()?.mandatory;

      if (DEBUG) {
        console.log('Server App Version:', serverVersion);
        console.log('Current App Version:', currentVersion);
        console.log('Env', import.meta.env.VITE_ENV);
        console.log('Is Internal User:', isInternalUser);
        console.log('Is Mandatory Update:', isMandatory);
      }

      if ((!isDev || DEBUG) && serverVersion && serverVersion !== currentVersion) {
        setUpdateRequired(isInternalUser || isMandatory);
      }
    });

    return () => unsubscribe();
  }, [currentVersion]);

  const forceReload = useCallback(() => {
    // Forces a hard-refresh bypassing cache
    window.location.reload();
  }, []);

  return { updateRequired, forceReload, timer, progress };
};

export default useAppVersionWatcher;
